import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as Save } from '../../../assets/svg/Save.svg';
import { Controller, useForm } from 'react-hook-form';
import Loading from '../../../utils/Loading';
import { updateUser } from '../../../server/server';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { notif } from '../../utils/util';

function CreateEditUserModal({
    modalIsOpen,
    closeModal,
    userProfile = null,
    reloadUserUpdate,
}: {
    modalIsOpen: any;
    closeModal: any;
    userProfile: any;
    reloadUserUpdate?: any;
}) {
    const [processing, setProcessing] = useState(false);
    const [valid, setValid] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const { register, handleSubmit, watch, reset, formState, getValues, setValue, control } = useForm({
        defaultValues: {
            username: '',
            email: '',
            endDate: new Date(),
        },
    });
    const { isDirty, isValid, errors } = formState;

    useEffect(() => {
        const element = document.getElementById('home');
        ReactModal.setAppElement('#root');
        if (modalIsOpen) {
            if (!!element) element.style.filter = 'blur(5px)';
            if (!!userProfile?.id) {
                setValue('username', userProfile?.username, { shouldValidate: true });
                setValue('email', userProfile?.email, { shouldValidate: true });
                setValid(userProfile?.valid);
                setIsAdmin(userProfile?.isAdmin);
                setIsSuperAdmin(userProfile?.isSuperAdmin);
                setValue('endDate', userProfile?.endDate);
            }
        } else {
            if (!!element) element.style.filter = 'unset';
        }
    }, [modalIsOpen, userProfile]);

    const onSubmit = async () => {
        console.log('values ', getValues());
        const data: any = getValues();
        data.valid = valid;
        data.isAdmin = isAdmin;
        data.isSuperAdmin = isSuperAdmin;
        const resp = await updateUser(data);
        if (resp.status === 201) {
            reloadUserUpdate();
            notif('Korisnik uspešno izmenjen');
            closeModal();
        } else {
            notif('Korisnik nije izmenjen. Došlo je do greške.');
            console.log('error', resp.data);
        }
    };

    const changeValid = () => {
        setValid((prev) => !prev);
    };

    const cleanUpFunction = () => {
        reset();
    };

    return (
        <ReactModal
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => cleanUpFunction()}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    zIndex: 8,
                    background: '#00000045',
                },
                content: {
                    padding: 0,
                    paddingTop: 30,
                    paddingBottom: 30,
                    opacity: 1,
                    width: 900,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '100vh',
                    border: '0px',
                    boxShadow: 'none',
                    overflow: 'auto',
                    outlineWidth: 0,
                },
            }}
            className={'scrollbar-display-none no-scroll outline-0'}
        >
            <div className="student-info-modal  ">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="close-modal-icon " onClick={() => closeModal()}>
                        <CloseModalIcon />
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} className="bg-white rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[30px]">
                    <div className="flex flex-row items-center">
                        <div className="flex-1">
                            <p className="text-primaryViolet font-semibold text-3xl text-left">
                                {userProfile === null ? 'Create new user' : 'Edit user profile'}
                            </p>
                        </div>
                    </div>
                    <div className="mt-5">
                        <p className="text-primaryViolet font-semibold text-lg text-left">User name</p>
                        <div
                            className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.username?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}
                        >
                            <input
                                className={`w-full text-primaryViolet ${errors.username?.type === 'required' ? 'placeholder:text-redError' : ''}`}
                                placeholder={`Type name`}
                                {...register('username', { required: true })}
                                style={{ backgroundColor: 'transparent' }}
                            />
                            <p className="text-redError   text-nowrap">{errors.username?.type === 'required' ? '*This field is required' : ''}</p>
                        </div>
                    </div>

                    <div className="mt-5">
                        <p className="text-primaryViolet font-semibold text-lg text-left">Email</p>
                        <div
                            className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.email?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}
                        >
                            <input
                                className={`w-full text-primaryViolet ${errors.email?.type === 'required' ? 'placeholder:text-redError' : ''}`}
                                placeholder={`Type email`}
                                {...register('email', { required: true })}
                                style={{ backgroundColor: 'transparent' }}
                            />
                            <p className="text-redError   text-nowrap">{errors.email?.type === 'required' ? '*This field is required' : ''}</p>
                        </div>
                    </div>
                    <div className="w-full">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeValid()}
                            >
                                {valid && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Korisnik Validan</label>
                        </div>
                    </div>
                    <div className="w-full">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => setIsAdmin((prev) => !prev)}
                            >
                                {isAdmin && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Korisnik Admin</label>
                        </div>
                    </div>
                    <div className="w-full">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => setIsSuperAdmin((prev) => !prev)}
                            >
                                {isSuperAdmin && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Korisnik Super Admin</label>
                        </div>
                    </div>
                    <div className="mt-5 ">
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="sr-cyrl">
                            <Controller
                                control={control}
                                name="endDate"
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <DatePicker
                                            label="Datum važenja pretplate"
                                            value={value ? dayjs(value) : null}
                                            onChange={(date: any) => {
                                                onChange(date ? date.toDate() : null);
                                            }}
                                            disabled={false}
                                        />
                                    );
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="flex flex-row justify-end w-full gap-5">
                        <div
                            className="flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer rounded-full bg-[#fafaff] hover:bg-grey-300  h-[60px] button-transparent-class"
                            onClick={closeModal}
                        >
                            <p className="text-[18px]  text-grey-700 leading-5 font-semibold mr-3 ">Back</p>
                        </div>
                        <button
                            className="flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-[#fafaff] hover:bg-grey-300  min-h-[60px] button-save-class transition"
                            disabled={processing}
                        >
                            {processing ? (
                                <Loading primaryColor="#FDDF6D" secondaryColor="#5E639B" size={25} stroke={7} />
                            ) : (
                                <div className="flex flex-row items-center justify-center">
                                    <p className="text-[18px]  leading-5 font-semibold mr-3 text-grey-700 ">Save</p>
                                    <Save color="#616161" />
                                </div>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </ReactModal>
    );
}

export default CreateEditUserModal;
